import {getBoundingClientRect} from './helpers/getBoundingClientRect';

const CLASS_BREADCRUMB = 'bs-site-logo--with-breadcrumb';

export function match(logoElement) {
	return logoElement.classList.contains(CLASS_BREADCRUMB);
}

export function init(store) {
	const logoBreadcrumbListE = document.querySelector(
		'.bs-site-logo__breadcrumb-list'
	);
	const logoBreadcrumbWrapperE = document.querySelector(
		'.bs-site-logo__breadcrumb-wrapper'
	);
	const contentLogoE = document.querySelector(
		'.bs-site-logo .bs-site-head-content'
	);

	return function update() {
		const {borderWidth, logoSize} = store.getState();

		const {width} = getBoundingClientRect(logoBreadcrumbListE);
		const {width: contentWrapperWidth} =
			getBoundingClientRect(contentLogoE);
		const breadcrumbWrapperWidth =
			contentWrapperWidth - logoSize - borderWidth * 2;
		const isContentBiggerThanContainer = width < breadcrumbWrapperWidth;

		logoBreadcrumbWrapperE.classList[
			isContentBiggerThanContainer ? 'remove' : 'add'
		]('bs-site-logo__breadcrumb-wrapper--has-overflow');
	};
}
